<template>
    <div>
        <div v-if="!hasErrors" class="row mb-3">
            <div class="col-4"></div>
            <div class="col-8 text-right">
                <week-handler
                    :start="meta.start"
                    :end="meta.end"
                    :next="meta.next"
                    :prev="meta.prev"
                />
            </div>
        </div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>

            <b-table
                responsive
                small
                :items="items"
                :fields="fields"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="id"
                @filtered="onFiltered"
            >
                <template #cell(d1)="data">
                    <month-charge-handler :charge="data.item.d1.duration" />
                </template>
                <template #cell(d2)="data">
                    <month-charge-handler :charge="data.item.d2.duration" />
                </template>
                <template #cell(d3)="data">
                    <month-charge-handler :charge="data.item.d3.duration" />
                </template>
                <template #cell(d4)="data">
                    <month-charge-handler :charge="data.item.d4.duration" />
                </template>
                <template #cell(d5)="data">
                    <month-charge-handler :charge="data.item.d5.duration" />
                </template>
                <template #cell(d6)="data">
                    <month-charge-handler :charge="data.item.d6.duration" />
                </template>
                <template #cell(sum)="data">
                    <month-charge-handler :charge="data.item.sum.duration" />
                </template>

                <template slot="bottom-row">
                    <td class="td-bold">TOTAL</td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalD1" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalD2" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalD3" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalD4" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalD5" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalD6" />
                    </td>
                    <td class="text-right td-bold">
                        <month-charge-handler :charge="totalSum" />
                    </td>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TableHandler from '../../../common/mixins/TableHandler.vue'
import MonthChargeHandler from '../../../common/components/MonthChargeHandler.vue'
import loading from '../../../common/components/loading.vue'
import weekHandler from '../components/WeekHandler.vue'

export default {
    name: 'CollaboratorsWeekReport',

    components: {
        MonthChargeHandler,
        loading,
        weekHandler,
    },

    mixins: [TableHandler],

    props: {
        todayY: '',
        todayM: '',
        todayD: '',
    },

    data() {
        return {
            meta: {},
            fields: [
                {
                    key: 'name',
                    label: 'Collaborateur',
                    sortable: true,
                },
                {
                    key: 'd1',
                    label: 'lun',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'd2',
                    label: 'mar',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'd3',
                    label: 'mer',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'd4',
                    label: 'jeu',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'd5',
                    label: 'ven',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'd6',
                    label: 'sam',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'sum',
                    label: 'TOTAL',
                    sortable: true,
                    class: 'text-right td-bold',
                },
            ],
        }
    },

    async created() {
        this.$store.commit(
            'browsing/SET_PAGE_NAME',
            'accountingFirmTimeSheetWeekReport'
        )
        this.$store.commit(
            'timeSheetsVM/SET_CURRENT_DATE',
            `${this.todayY}/${this.todayM}/${this.todayD}`
        )
        await this.getItems()
    },

    methods: {
        async getItems() {
            try {
                this.loading = true
                const response = await axios.get(
                    `/time-sheets/reporting/accountingFirms/week/${this.currentDate}`
                )
                this.items = response.data.data
                this.meta = response.data.meta
                this.loading = false
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },
    },

    computed: {
        ...mapState({
            accountingFirmUser: (state) =>
                state.timeSheetsVM.filters.accountingFirmUser,
            currentDate: (state) => state.timeSheetsVM.currentDate,
        }),

        totalD1() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.d1.duration),
                0
            )
        },

        totalD2() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.d2.duration),
                0
            )
        },

        totalD3() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.d3.duration),
                0
            )
        },

        totalD4() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.d4.duration),
                0.0
            )
        },

        totalD5() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.d5.duration),
                0
            )
        },

        totalD6() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.d6.duration),
                0
            )
        },

        totalSum() {
            return this.items.reduce(
                (accum, item) => accum + parseFloat(item.sum.duration),
                0
            )
        },
    },
}
</script>

<style scoped></style>
